<!-- Form input for Polish PESEL national ID numbers, masked to 11 digits. -->

<script lang="ts" setup>
import type { FormFieldController } from '@nzyme/vue-forms/components/defineFormField.js';
import { useMaskedInput } from '@nzyme/vue-forms/components/useMaskedInput.jsx';
import type { Slots } from '@nzyme/vue-utils/slots.js';
import { computed } from 'vue';

import FormFieldWrapper from './FormFieldWrapper.vue';

const props = defineProps({
  ...useMaskedInput.props,
});

defineEmits(useMaskedInput.emits);
defineSlots<Slots<{ info: { field: FormFieldController<string> } }>>();

const { MaskedInput, field } = useMaskedInput({
  maskConfig: {
    mask: '00000000000',
    inputmode: 'numeric',
    lazy: false,
    placeholderChar: ' ',
  },
  toModelValue: (typedValue: unknown) => {
    if (typeof typedValue !== 'string') {
      return null;
    }

    return typedValue.trim();
  },
  toTypedValue: (modelValue: string | null | undefined) => {
    return modelValue || '';
  },
});

// Properly typed field for template
const typedField = computed(() => field);
</script>

<template>
  <FormFieldWrapper
    :field="typedField"
    :label="props.label"
    :required="props.required"
    :disabled="props.disabled"
    :readonly="props.readonly"
  >
    <template #default="{ inputId }">
      <MaskedInput
        :id="inputId"
        name="pesel"
        autocomplete="off"
        :class="css.input"
      />
    </template>

    <template #info>
      <slot
        name="info"
        :field="typedField"
      />
    </template>
  </FormFieldWrapper>
</template>

<style lang="scss" module="css">
.input {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.15em;
  font-size: $font-size-20;
}
</style>
